import React from 'react'
import { Navbar } from './Navbar'
import { Stepper } from '../ui/Stepper'

interface OnboardingLayoutProps {
  children: React.ReactNode
  steps?: Array<{
    id: string
    title: string
    description?: string
    status: 'pending' | 'current' | 'completed'
  }>
  showStepper?: boolean
}

export const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({
  children,
  steps = [],
  showStepper = true,
}) => {
  return (
    <>
      {/* Mobile Layout */}
      <div className="min-h-screen flex flex-col md:hidden">
        {/* Mobile Header */}
        <Navbar logoSize="large" />

        {/* Mobile Content */}
        <div className="flex-1 bg-olr-white p-6">
          <div className="max-w-md mx-auto">
            {/* Progress Stepper for mobile */}
            {showStepper && steps.length > 0 && (
              <div className="mb-8 flex justify-center">
                <div className="max-w-lg w-full">
                  <Stepper
                    steps={steps}
                    variant="mobile"
                    className="justify-center"
                  />
                </div>
              </div>
            )}
            {children}
          </div>
        </div>
      </div>

      {/* Desktop Layout: mismo shell de cuenta (Navbar) que se usa en "Mis
          cotizaciones" y hermanas, para emparejar el diseño de los pasos de
          onboarding con el resto de la app. El sidebar de cuenta
          (AccountSidebar) se quita a propósito: durante los pasos de
          onboarding el usuario todavía no tiene nada que navegar ahí (ver
          useHasCompletedCreditApplication). El candado de progressUrl no se
          ve afectado por esto — sigue decidiéndose en ProgressGuard, no por
          lo que se muestre aquí. */}
      <div className="hidden md:flex min-h-screen flex-col bg-olr-grey-1">
        <div className="sticky top-0 z-40">
          <Navbar />
        </div>

        <div className="flex flex-1 flex-col">
          {/* Progress Stepper - Fixed at top */}
          {showStepper && steps.length > 0 && (
            <div className="pt-8 pb-4">
              <div className="max-w-4xl mx-auto px-8">
                <Stepper
                  steps={steps}
                  variant="desktop"
                  orientation="horizontal"
                  className="justify-center"
                />
              </div>
            </div>
          )}

          {/* Content Area */}
          <div className="flex-1 flex justify-center px-8 pb-12">
            <div className="w-full max-w-3xl pt-4">{children}</div>
          </div>
        </div>
      </div>
    </>
  )
}
